export class FacebookPost {
    public actions: { link: string }[];
    public from: { name: string, id: string, picture: string, link: string };
    public id: string;
    public permalink_url: string;
    public link: string;
    public message: string;
    public story: string;
    public picture: string;
    public full_picture: string;
    public updated_time: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/facebook.post/facebook.post.ts